import { Route } from 'vue-router/types/router';

type RoutePropsFunction<T = {}> = (route: Route) => T

export const withNamedProp = <K extends string, T = string>(paramNames: string[], prop: K, transformer: (p: string) => T): RoutePropsFunction<{ [P in K]: T }> =>
  (route: Route) => {
    const value = paramNames.map(r => route.params[r]).find(r => r !== undefined);

    if (value === undefined) {
      throw new Error(`Route param not found: ${paramNames.join(', ')}`);
    }

    return {
      [prop]: transformer(value),
    } as { [P in K]: T };
  };

export type CombinedRoutePropsReturnType<T extends RoutePropsFunction[]> =
  T extends Array<infer U>
  ? U extends RoutePropsFunction
  ? UnionToIntersection<ReturnType<T[number]>>
  : unknown
  : unknown;

type UnionToIntersection<U> =
  (U extends {} ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const withRouteProps =
  <T extends RoutePropsFunction[]>(
    ...props: T
  ): ((route: Route) => CombinedRoutePropsReturnType<T>) =>
    (route: Route) => {
      return props.reduce(
        (acc, prop) => {
          if (Array.isArray(prop)) {
            return { ...acc, ...withRouteProps(...prop)(route) };
          }

          return { ...acc, ...prop(route) };
        },
        {}
      ) as CombinedRoutePropsReturnType<T>;
    };

  
export const withCompanyIdProp = withNamedProp(['company', 'companyId'], 'companyId', (p: string) => +p);

export const withJobIdProp = withNamedProp(['job', 'ad', 'posting', 'postingId'], 'postingId', (p: string) => +p);
